"use client";

import { usePathname } from "next/navigation";
import { useEffect, useState, type ReactNode } from "react";
import { Box, CircularProgress } from "@mui/material";

import { getCurrentUser } from "@/features/auth/api";
import { AppShell } from "./app-shell";

// The actual enforcement lives server-side (every API router except /auth and /health
// requires a valid session — see apps/backend/app/main.py). This client-side check just
// avoids flashing authenticated UI before the first API call would otherwise redirect.
export function AuthGate({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (pathname === "/login") return;
    let cancelled = false;
    getCurrentUser()
      .catch(() => {
        // apiRequest already redirects to /login on a 401; nothing further to do here.
      })
      .finally(() => {
        if (!cancelled) setChecked(true);
      });
    return () => {
      cancelled = true;
    };
  }, [pathname]);

  if (pathname === "/login") {
    return <>{children}</>;
  }

  if (!checked) {
    return (
      <Box sx={{ minHeight: "100dvh", display: "grid", placeItems: "center" }}>
        <CircularProgress size={28} />
      </Box>
    );
  }

  return <AppShell>{children}</AppShell>;
}
